/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Initial_Context_DescriptionInputs */

const en_notes_initial_context_description = /** @type {(inputs: Notes_Initial_Context_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record any initial notes or context for this case.`)
};

const pt_br2_notes_initial_context_description = /** @type {(inputs: Notes_Initial_Context_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registre observações iniciais ou contexto para este caso.`)
};

/**
* | output |
* | --- |
* | "Record any initial notes or context for this case." |
*
* @param {Notes_Initial_Context_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notes_initial_context_description = /** @type {((inputs?: Notes_Initial_Context_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Initial_Context_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notes_initial_context_description(inputs)
	return pt_br2_notes_initial_context_description(inputs)
});